import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=34aa122a"
import script from "./Balances.vue?vue&type=script&lang=js"
export * from "./Balances.vue?vue&type=script&lang=js"
import style0 from "./Balances.vue?vue&type=style&index=0&id=34aa122a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports